import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updateMessage.loading;
export const sendMessageErrorMessage = (state: RootState) =>
  state.updateMessage.error;
export const updateMessageDataResponse = (state: RootState) =>
  state.updateMessage.updateMessageResponse;
